export default __webpack_public_path__ + "1ae42874056d6ca63dd79eb1cf5d2e05.png";